<div class="mapContent"> 
    <app-source-map></app-source-map>
</div>

<div class="parcelfields">
    <h2>اختيار قطعة الأرض</h2>
      <div class="input-field">
        <label for="baladeya"> البلدية </label>
        <select id="baladeya" (change)="onBaladeyaNameChange($event)">
          <option value="">All</option>
          <option *ngFor="let option of baladeyaNameOptions" [value]="option">
            {{ option }}
          </option>
        </select>
      </div>

      <div class="input-field">
        <label for="neigh"> اسم الحي </label>
        <select id="neigh" (change)="onNeighNameChange($event)">
          <option value="">All</option>
          <option *ngFor="let option of neighNameOptions" [value]="option">
            {{ option }}
          </option>
        </select>
      </div>
     
      <div class="input-field">
        <label for="planName"> اسم المخطط </label>
        <select id="planName" (change)="onPlanNameChange($event)">
          <option value="">All</option>
          <option *ngFor="let option of planNameOptions" [value]="option">
            {{ option }}
          </option>
        </select>
      </div>
      <div class="input-field">
        <label for="parcelno"> رقم القطعة </label>
        <select id="parcelno" (change)="onParcelNoChange($event)">
          <option value="">All</option>
          <option *ngFor="let option of parcelNoOptions" [value]="option">
            {{ option }}
          </option>
        </select>
      </div>

      
    <div style="overflow-y: scroll; height: 40vh;">
        
         <div class="input-field">
          <label for="zoneCode">كود النطاق</label>
          <input type="text" id="zoneCode" [(ngModel)]="zoneCode">
         </div>
  
         <div class="input-field">
          <label for="balady2">بلدي 2</label>
          <input type="text" id="balady2" [(ngModel)]="balady2">
         </div>
  
         <div class="input-field">
          <label for="areaPhotography">مرحلة عمل التصوير الجوي</label>
          <input type="text" id="areaPhotography" [(ngModel)]="areaPhotography">
         </div>
  
         <div class="input-field">
            <label for="planCorrection">مرحلة التصحيح بالمخطط</label>
            <input type="text" id="planCorrection" [(ngModel)]="planCorrection">
         </div>
           
    </div>
    <button class="btn btn-primary" (click)="saveParcelDetails()">save</button>
</div>